// src/store/features/ui/uiSelectors.js

// Sidebar & Theme
export const selectIsSidebarOpen = (state) => state.ui.isSidebarOpen;
export const selectIsDarkMode = (state) => state.ui.isDarkMode;

// Input Bar
export const selectIsInputFocused = (state) => state.ui.isInputFocused;
export const selectIsInputDisabled = (state) => state.ui.isInputDisabled;
export const selectInputPlaceholder = (state) => state.ui.inputPlaceholder;
export const selectInputValue = (state) => state.ui.inputValue;
export const selectIsTyping = (state) => state.ui.isTyping;

// Send Button
export const selectSendButtonLoading = (state) => state.ui.sendButtonLoading;
export const selectSendButtonDisabled = (state) => state.ui.sendButtonDisabled;
export const selectSendButtonIcon = (state) => state.ui.sendButtonIcon;
export const selectSendButtonTooltip = (state) => state.ui.sendButtonTooltip;

// Mic Button
export const selectMicButtonLoading = (state) => state.ui.micButtonLoading;
export const selectMicButtonDisabled = (state) => state.ui.micButtonDisabled;
export const selectMicButtonIcon = (state) => state.ui.micButtonIcon;
export const selectMicButtonTooltip = (state) => state.ui.micButtonTooltip;
export const selectIsRecording = (state) => state.ui.isRecording;
export const selectMicButtonType = (state) => state.ui.micButtonType;
export const selectIsMicButtonClicked = (state) => state.ui.isMicButtonClicked;
// Suggestions
export const selectSuggestions = (state) => state.ui.suggestions;
export const selectSuggestionsLoading = (state) => state.ui.suggestionsLoading;
export const selectSuggestionsError = (state) => state.ui.suggestionsError;
export const selectIsSuggestionsVisible = (state) =>
  state.ui.isSuggestionsVisible;

export const selectIsNewChatClicked = (state) => state.ui.isNewChatClicked;
export const selectIsGrievanceRegistering = (state) =>
  state.ui.isGrievanceRegistering;

// voice Journey bg music mute/unmute button states and controls
export const selectIsVoiceMuteButtonVisible = (state) =>
  state.ui.isVoiceMuteButtonVisible;
export const selectIsVoiceJourneyBgMuted = (state) =>
  state.ui.isVoiceJourneyBgMuted;
export const selectIsVoiceProcessing = (state) => state.ui.isVoiceProcessing;
export const selectIsBigMicButtonClicked = (state) =>
  state.ui.isBigMicButtonClicked;
export const selectIsTextFromBigMicButton = (state) =>
  state.ui.isTextFromBigMicButton;
export const selectIsSendTriggeredFromSocket = (state) =>
  state.ui.isSendTriggeredFromSocket;

// Other Selectors
